<div class="wrapper">
  <div class="main">
    Факт
  </div>
  <div class="additional">
    Вышло/Ожидаем
  </div>
</div>
